export type RuleSection = {
  title: string;
  body: string;
};

const HEADING = /^(#{1,3})[ \t]+(\S.*?)\s*$/;

/** Kleinste vorhandene Überschriften-Stufe wird zum Aufklapp-Punkt. Tiefere Stufen bleiben im Text. */
export function splitRuleMarkdown(markdown: string): RuleSection[] {
  const lines = (markdown || '').replace(/\r\n/g, '\n').split('\n');
  const levels = lines
    .map(line => line.match(HEADING))
    .filter((match): match is RegExpMatchArray => Boolean(match))
    .map(match => match[1].length);
  if (!levels.length) {
    const pre = lines.join('\n').trim();
    return pre ? [{ title: 'Regeln', body: pre }] : [];
  }
  const mainLevel = Math.min(...levels);
  const sections: RuleSection[] = [];
  let title: string | null = null;
  let body: string[] = [];
  const preamble: string[] = [];
  let started = false;

  const push = () => {
    if (title === null) return;
    sections.push({ title: title.slice(0, 255), body: body.join('\n').trim() });
  };

  lines.forEach(line => {
    const match = line.match(HEADING);
    if (match && match[1].length === mainLevel) {
      if (!started) {
        const pre = preamble.join('\n').trim();
        if (pre) sections.push({ title: 'Einleitung', body: pre });
        started = true;
      } else {
        push();
      }
      title = match[2].trim();
      body = [];
      return;
    }
    if (started) body.push(line);
    else preamble.push(line);
  });

  if (started) push();
  return sections;
}

export function rulesToMarkdown(rules: Array<{ title: string; content: string; order_index?: number }>): string {
  return [...rules]
    .sort((a, b) => (a.order_index ?? 0) - (b.order_index ?? 0))
    .map(rule => {
      const title = (rule.title || 'Regel').trim() || 'Regel';
      const body = (rule.content || '').trim();
      return body ? `# ${title}\n\n${body}` : `# ${title}`;
    })
    .join('\n\n');
}
